import { c as _c } from "react/compiler-runtime";
import { Badge, Tooltip } from "@flat-ui";
import { useTokenPurchase } from "@hooks/use-token-purchase";
import { NewCreditTooltip } from "@pages/settings/subscription-settings/credits/new-credit-tooltip";

/** Renders a dot icon as badge indicating newly purchased credit */
export function NewCreditBadge() {
  const $ = _c(2);
  const {
    shouldShowNewIndication
  } = useTokenPurchase();
  if (!shouldShowNewIndication) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NewCreditTooltip />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Tooltip component="div" title={t0}><Badge variant="dot" color="secondary" sx={{
        height: "24px",
        width: "24px",
        right: "15px",
        cursor: "pointer"
      }} /></Tooltip>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}